import { Box } from "@mui/material";
import React from "react";

const ErrorMessage = ({ message }) => {
  return <Box>Error: {message}</Box>;
};

export default ErrorMessage;
